(function () {
  if (window.__productCardQuickAddInit) return;
  window.__productCardQuickAddInit = true;

  var MOBILE_MQ = window.matchMedia('(max-width: 767px)');
  var SLIDE_DURATION = 400;
  var FORM_HIDE_DURATION = 180;
  var SLIDE_EASING = 'cubic-bezier(0.29, 0.63, 0.44, 1)';

  function getItemsEl(variantsEl) {
    return variantsEl && variantsEl.querySelector('.m-quick-add-variants__items');
  }

  function getCardEl(variantsEl) {
    return variantsEl && variantsEl.closest('.m-product-card');
  }

  function getBoundsEl(card) {
    var parent = card && card.parentElement;
    if (!parent) return null;
    if (parent.classList.contains('swiper-slide')) return parent.closest('.swiper') || parent;
    return parent;
  }

  function hasOpenQuickAdd(bounds) {
    return !!(
      bounds &&
      bounds.querySelector(
        '.m-product-card__quick-add--simple .m-quick-add-variants--open:not(.m-quick-add-variants--closing)'
      )
    );
  }

  function setSliderTouch(card, allow) {
    var bounds = getBoundsEl(card);
    var swiper = bounds && bounds.swiper;
    if (!swiper) return;

    if (allow && hasOpenQuickAdd(bounds)) return;

    swiper.allowTouchMove = allow;
    if (swiper.params) swiper.params.allowTouchMove = allow;

    if (!allow && swiper.autoplay && swiper.autoplay.stop) swiper.autoplay.stop();
    if (allow && swiper.autoplay && swiper.autoplay.start && swiper.params && swiper.params.autoplay) {
      swiper.autoplay.start();
    }
  }

  function forceUnlockSlider(card) {
    var bounds = getBoundsEl(card);
    var swiper = bounds && bounds.swiper;
    if (!bounds) return;

    bounds.classList.remove('m-swiper--quick-add-open', 'm-swiper--quick-add-closing');
    bounds.style.removeProperty('padding-bottom');

    if (!swiper) return;
    swiper.allowTouchMove = true;
    if (swiper.params) swiper.params.allowTouchMove = true;
  }

  function getReserveHeight(card, itemsHeight) {
    var bounds = getBoundsEl(card);
    var heading = card && card.querySelector('.m-product-card__heading');
    if (!bounds || !heading || !card.parentElement || !card.parentElement.classList.contains('swiper-slide')) {
      return 0;
    }

    var items = card.querySelector('.m-quick-add-variants__items');
    var form = card.querySelector('.m-product-card__heading .js-product-form');
    var boundsRect = bounds.getBoundingClientRect();
    var currentPad = parseFloat(window.getComputedStyle(bounds).paddingBottom) || 0;
    var contentBottom = boundsRect.bottom - currentPad;
    var panelBottom = heading.getBoundingClientRect().bottom;

    if (items && window.getComputedStyle(items).display !== 'none') {
      if (typeof itemsHeight === 'number') {
        panelBottom += itemsHeight;
      } else {
        panelBottom = Math.max(panelBottom, items.getBoundingClientRect().bottom);
      }
    }

    if (form && window.getComputedStyle(form).display !== 'none') {
      panelBottom = Math.max(panelBottom, form.getBoundingClientRect().bottom);
    }

    return Math.max(0, Math.ceil(panelBottom - contentBottom));
  }

  function setSliderSpace(card, paddingPx) {
    var bounds = getBoundsEl(card);
    if (!bounds || !MOBILE_MQ.matches) return;
    if (!card.parentElement || !card.parentElement.classList.contains('swiper-slide')) return;

    bounds.classList.remove('m-swiper--quick-add-closing');
    bounds.classList.add('m-swiper--quick-add-open');
    bounds.style.paddingBottom = Math.max(0, paddingPx) + 'px';
  }

  function collapseSliderSpace(card) {
    var bounds = getBoundsEl(card);
    if (!bounds) return;
    if (hasOpenQuickAdd(bounds)) return;

    bounds.classList.remove('m-swiper--quick-add-open');
    bounds.classList.add('m-swiper--quick-add-closing');
    bounds.style.paddingBottom = '0px';

    window.setTimeout(function () {
      if (bounds.classList.contains('m-swiper--quick-add-open')) return;
      bounds.classList.remove('m-swiper--quick-add-closing');
      bounds.style.removeProperty('padding-bottom');
    }, SLIDE_DURATION);
  }

  function clearQuickAddPanelVars(card) {
    if (!card) return;
    card.style.removeProperty('--quick-add-offset-left');
    card.style.removeProperty('--quick-add-panel-width');
    card.style.removeProperty('--quick-add-items-height');
  }

  function updateItemsHeight(card, height) {
    if (!card) return;

    if (typeof height === 'number') {
      card.style.setProperty('--quick-add-items-height', Math.max(0, height) + 'px');
      return;
    }

    var items = card.querySelector('.m-quick-add-variants__items');
    if (!items || window.getComputedStyle(items).display === 'none') {
      card.style.setProperty('--quick-add-items-height', '0px');
      return;
    }

    card.style.setProperty('--quick-add-items-height', items.offsetHeight + 'px');
  }

  function getOpenItemsTargetHeight(items) {
    if (!items) return 0;

    var inlineHeight = parseFloat(items.style.height);
    if (inlineHeight > 0) return inlineHeight;

    var style = items.style;
    var prevHeight = style.height;
    var prevOverflow = style.overflow;
    var prevPaddingTop = style.paddingTop;
    var prevPaddingBottom = style.paddingBottom;
    var prevMarginTop = style.marginTop;
    var prevMarginBottom = style.marginBottom;

    style.height = 'auto';
    style.overflow = 'hidden';
    style.removeProperty('padding-top');
    style.removeProperty('padding-bottom');
    style.removeProperty('margin-top');
    style.removeProperty('margin-bottom');

    var height = items.offsetHeight;

    style.height = prevHeight;
    style.overflow = prevOverflow;
    style.paddingTop = prevPaddingTop;
    style.paddingBottom = prevPaddingBottom;
    style.marginTop = prevMarginTop;
    style.marginBottom = prevMarginBottom;

    return height;
  }

  function setQuickAddPanelVars(card, options) {
    options = options || {};

    if (!card || !MOBILE_MQ.matches) {
      clearQuickAddPanelVars(card);
      return;
    }

    var bounds = getBoundsEl(card);
    var heading = card.querySelector('.m-product-card__heading');
    if (!bounds || !heading) return;

    var headingRect = heading.getBoundingClientRect();
    var boundsRect = bounds.getBoundingClientRect();

    card.style.setProperty('--quick-add-offset-left', boundsRect.left - headingRect.left + 'px');
    card.style.setProperty('--quick-add-panel-width', boundsRect.width + 'px');

    if (options.itemsHeight != null) {
      updateItemsHeight(card, options.itemsHeight);
    } else {
      updateItemsHeight(card);
    }
  }

  function animateOpenPanelHeight(card) {
    if (!card || !MOBILE_MQ.matches) return;

    updateItemsHeight(card, 0);

    function applyTargetHeight() {
      var items = card.querySelector('.m-quick-add-variants__items');
      if (!items || window.getComputedStyle(items).display === 'none') return false;
      var height = getOpenItemsTargetHeight(items);
      if (height <= 0) return false;
      updateItemsHeight(card, height);
      setSliderSpace(card, getReserveHeight(card, height));
      return true;
    }

    window.requestAnimationFrame(function () {
      if (applyTargetHeight()) return;
      window.requestAnimationFrame(applyTargetHeight);
    });

    window.setTimeout(function () {
      if (!card.querySelector('.m-quick-add-variants--open')) return;
      updateItemsHeight(card);
      setSliderSpace(card, getReserveHeight(card));
    }, SLIDE_DURATION);
  }

  function clearItemsTransitionStyles(items) {
    if (!items) return;
    [
      'height',
      'overflow',
      'transition-property',
      'transition-duration',
      'transition-timing-function',
      'padding-top',
      'padding-bottom',
      'margin-top',
      'margin-bottom',
      'box-sizing',
    ].forEach(function (prop) {
      items.style.removeProperty(prop);
    });
  }

  function slideUp(el, duration, onComplete) {
    if (!el) {
      if (onComplete) onComplete();
      return;
    }

    el.style.transitionProperty = 'height, margin, padding';
    el.style.transitionDuration = duration + 'ms';
    el.style.transitionTimingFunction = SLIDE_EASING;
    el.style.boxSizing = 'border-box';
    el.style.height = el.offsetHeight + 'px';
    el.offsetHeight;
    el.style.overflow = 'hidden';
    el.style.height = '0';
    el.style.paddingTop = '0';
    el.style.paddingBottom = '0';
    el.style.marginTop = '0';
    el.style.marginBottom = '0';

    window.setTimeout(function () {
      el.style.display = 'none';
      clearItemsTransitionStyles(el);
      if (onComplete) onComplete();
    }, duration);
  }

  function closeQuickAddVariants(variantsEl) {
    if (!variantsEl || !variantsEl.classList.contains('m-quick-add-variants--open')) return;
    if (variantsEl.classList.contains('m-quick-add-variants--closing')) return;

    variantsEl.classList.add('m-quick-add-variants--closing');

    var items = getItemsEl(variantsEl);
    var card = getCardEl(variantsEl);

    window.setTimeout(function () {
      if (card && MOBILE_MQ.matches) updateItemsHeight(card, 0);

      collapseSliderSpace(card);

      slideUp(items, SLIDE_DURATION, function () {
        variantsEl.classList.remove('m-quick-add-variants--open');
        variantsEl.classList.remove('m-quick-add-variants--closing');
        clearQuickAddPanelVars(card);
        setSliderTouch(card, true);
      });
    }, FORM_HIDE_DURATION);
  }

  function closeAllSimpleQuickAdds(except) {
    document.querySelectorAll('.m-product-card__quick-add--simple .m-quick-add-variants--open').forEach(function (variantsEl) {
      if (except && variantsEl === except) return;
      closeQuickAddVariants(variantsEl);
    });
  }

  var COLOR_OPTION_NAMES = ['color', 'colour', 'kleur', 'farbe', 'couleur', 'colore'];

  function isColorOption(name) {
    return COLOR_OPTION_NAMES.indexOf(String(name || '').trim().toLowerCase().replace(/:$/, '')) !== -1;
  }

  function clearLockedColor(variantsEl) {
    if (!variantsEl) return;

    var locked = variantsEl.querySelector('.m-quick-add-variants__locked-color');
    if (locked) locked.remove();

    variantsEl.querySelectorAll('[data-quick-add-color-locked="true"]').forEach(function (fieldset) {
      fieldset.classList.remove('a-hide');
      fieldset.removeAttribute('data-quick-add-color-locked');
    });
  }

  function syncLockedColorFromCard(card, variantsEl) {
    if (!card || !variantsEl) return;

    var variantsRoot = variantsEl.querySelector('.js-variants-quick-add');
    var items = getItemsEl(variantsEl);
    var activeSwatch = card.querySelector('.m-product-card__swatches .js-swatch.m-variants__swatch--active');

    if (!variantsRoot || !items || !activeSwatch) {
      clearLockedColor(variantsEl);
      return;
    }

    variantsRoot.querySelectorAll('.m-variants__fieldset').forEach(function (fieldset) {
      var option = fieldset.getAttribute('data-option');
      var legend = fieldset.querySelector('legend');
      if (!isColorOption(option) && !(legend && isColorOption(legend.textContent))) return;
      fieldset.classList.add('a-hide');
      fieldset.setAttribute('data-quick-add-color-locked', 'true');
    });

    var locked = items.querySelector('.m-quick-add-variants__locked-color');
    if (!locked) {
      locked = document.createElement('div');
      locked.className = 'm-variants__fieldset m-quick-add-variants__locked-color';
      locked.innerHTML =
        '<div class="m-variants__legend a-input__label"></div>' +
        '<div class="m-variants__swatches"><div class="m-variants__swatch m-variants__swatch--active"></div></div>';
    }

    if (variantsRoot.nextSibling !== locked) {
      items.insertBefore(locked, variantsRoot.nextSibling);
    }

    var colorNameEl = card.querySelector('.m-product-card__swatches .m-variants__legend span');
    var colorName = colorNameEl ? colorNameEl.textContent.trim() : '';
    var label = variantsRoot.getAttribute('data-color-label') || 'Color';
    locked.querySelector('.m-variants__legend').textContent = colorName ? label + ': ' + colorName : label;

    var swatchTarget = locked.querySelector('.m-variants__swatch');
    var activeVisual = activeSwatch.querySelector('.a-swatch');
    swatchTarget.innerHTML = '';
    if (activeVisual) swatchTarget.appendChild(activeVisual.cloneNode(true));
  }

  function init() {
    document.addEventListener(
      'click',
      function (event) {
        var toggleBtn = event.target.closest('.js-quick-add-toggle button');
        if (toggleBtn) {
          var variantsEl = toggleBtn.closest('.js-quick-add-variants');
          var card = toggleBtn.closest('.m-product-card');
          syncLockedColorFromCard(card, variantsEl);

          if (toggleBtn.closest('.m-product-card__quick-add--simple')) {
            if (variantsEl && variantsEl.classList.contains('m-quick-add-variants--open')) {
              event.preventDefault();
              event.stopPropagation();
              closeQuickAddVariants(variantsEl);
              return;
            }

            closeAllSimpleQuickAdds(variantsEl);
            setSliderTouch(card, false);
            setQuickAddPanelVars(card, { itemsHeight: 0 });
            animateOpenPanelHeight(card);
          }
        }
      },
      true
    );

    document.addEventListener('click', function (event) {
      var closeTrigger = event.target.closest('.js-quick-add-close');
      if (closeTrigger) {
        event.preventDefault();
        event.stopPropagation();
        closeQuickAddVariants(closeTrigger.closest('.js-quick-add-variants'));
        return;
      }

      var simpleQuickAdd = event.target.closest('.m-product-card__quick-add--simple');
      if (simpleQuickAdd) return;

      if (event.target.closest('.m-product-card__heading .m-quick-add-variants__items')) return;
      if (event.target.closest('.m-product-card__heading .js-product-form')) return;

      closeAllSimpleQuickAdds();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      closeAllSimpleQuickAdds();
    });

    window.addEventListener('resize', function () {
      if (!MOBILE_MQ.matches) {
        document
          .querySelectorAll('.m-swiper--quick-add-open, .m-swiper--quick-add-closing')
          .forEach(function (bounds) {
            var card = bounds.querySelector('.m-product-card');
            if (card) forceUnlockSlider(card);
            else {
              bounds.classList.remove('m-swiper--quick-add-open', 'm-swiper--quick-add-closing');
              bounds.style.removeProperty('padding-bottom');
              if (bounds.swiper) {
                bounds.swiper.allowTouchMove = true;
                if (bounds.swiper.params) bounds.swiper.params.allowTouchMove = true;
              }
            }
          });
        return;
      }

      document.querySelectorAll('.m-product-card__quick-add--simple .m-quick-add-variants--open').forEach(function (variantsEl) {
        var card = getCardEl(variantsEl);
        setQuickAddPanelVars(card);
        setSliderSpace(card, getReserveHeight(card));
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
